module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.params && _vm.params.isActive) ? _c('div', [_c('ModalDefault', {
    attrs: {
      "size": "m",
      "with-content": true,
      "theme": true,
      "fix-height": false,
      "fix-width": false,
      "loading": _vm.loading
    },
    on: {
      "close": function($event) {
        _vm.close();
      }
    }
  }, [_c('template', {
    slot: "main"
  }, [_c('section', {
    staticClass: "change-access"
  }, [_c('p', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$trad.changeAccess.title))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "html-safe",
      rawName: "v-html-safe",
      value: (
        _vm.$t(_vm.params.user.isEnabled ? 'changeAccess.activate' : 'changeAccess.desactivate', {
          fullName: _vm.params.user.fullName
        })
      ),
      expression: "\n                        $t(params.user.isEnabled ? 'changeAccess.activate' : 'changeAccess.desactivate', { fullName: params.user.fullName })\n                    "
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "row d-flex justify-content-end"
  }, [_c('ClientColorButton', {
    staticClass: "mr-3",
    attrs: {
      "background-color": _vm.currentBrand.linksColor
    },
    on: {
      "click": function($event) {
        _vm.changeAccess();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("actions.confirm")))]), _vm._v(" "), _c('ClientColorButton', {
    attrs: {
      "inactiveColor": true
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.close();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("actions.cancel")))])], 1)])])], 2)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c680d12","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/actions/ChangeAccess.vue
// module id = 3096
// module chunks = 0